import axios from "axios";
import React, { useEffect, useState } from "react";
import { getCurrentDate } from "../../../../Utilitie";
import Report02 from "./Report02";
import Report02Graph from "./Report02Graph";
import PuncMonthlyReport from "./PuncMonthlyReport";
const ReportMaster = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [globalDate, setGlobalDate] = useState(getCurrentDate());
  const [show, setShow] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const a = gridData?.filter(
    (o) =>
      o.group_type === "totalM" ||
      o.group_type === "totalP" ||
      (o.group_type === "MPSO" && o.train_type === "PAS") ||
      (o.group_type === "MPSO" && o.train_type === "TOD"),
  );

  const convertData = (arr) => {
    return arr.map((item) => {
      return {
        name: item.group_type,
        // train_type: item.train_type,
        data: [
          item.PP_CFY_DAY,
          item.PP_CFY_MONTH,
          item.PP_CFY,
          item.PP_LFY_DAY,
          item.PP_LFY_MONTH,
          item.PP_LFY,
          item.PP_FY_DIFF,
        ],
      };
    });
  };

  const results = convertData(a);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://railsetu.in:5310/get_icms_report02?start=${globalDate}&end=${globalDate}`,
      );
      if (response.data.status === "ok") {
        setGridData(response.data.daterange.report02);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [globalDate]);
  const fetchGraphData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `  https://railsetu.in:5310/get_7days_report02?start=${globalDate}`,
      );

      if (response.data.status === "ok") {
        setGraphData(response.data.days7);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchGraphData();
  }, [globalDate]);

  return (
    <div className="newUiBody">
      {" "}
      <div className="mb-1">
        Select Date:{" "}
        <input
          type="date"
          className="form-control d-inline-block"
          style={{ width: "180px", fontSize: "0.9rem" }}
          value={globalDate}
          max={getCurrentDate()}
          onChange={(e) => setGlobalDate(e.target.value)}
        />
      </div>
      <div className="row p-2 d-flex align-items-stretch">
        <div className="col-md-6">
          <div className="h-100 newUiBody ">
            {" "}
            {/* example consistent styling */}
            <Report02Graph data={graphData} a={a} globalDate={globalDate} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="h-100 newUiBody  ">
            <Report02 data={gridData} a={a} globalDate={globalDate} />
          </div>
        </div>
      </div>
      <div className="row p-2 d-flex align-items-stretch">
        <PuncMonthlyReport />
      </div>
    </div>
  );
};
export default ReportMaster;
